<template>
  <div class="store-body">
    <OrdersDineInPageToolbar
      class="mb-2"
      @setOrdersDineInPageSearch="handlePageSearch"
    />
    <OrdersDineInDataTable @setOrdersDineInTableSort="handleTableSort" />
    <OrdersDineInPagination @setPagination="handlePagination" />
    <OrdersDineInOrderDetailsModal />
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import OrdersDineInPageToolbar from "@/components/orders/orders-dine-in/OrdersDineInPageToolbar.vue";
import OrdersDineInDataTable from "@/components/orders/orders-dine-in/OrdersDineInDataTable.vue";
import OrdersDineInPagination from "@/components/orders/orders-dine-in/OrdersDineInPagination.vue";
import OrdersDineInOrderDetailsModal from "@/components/orders/orders-dine-in/OrdersDineInViewOrderDetailsModal.vue";
import _ from "lodash";

export default defineComponent({
  components: {
    OrdersDineInPageToolbar,
    OrdersDineInDataTable,
    OrdersDineInPagination,
    OrdersDineInOrderDetailsModal,
  },
  setup(props, { root }) {
    const searchPayload = ref({});
    const applySearchPayload = (page = 1) => {
      const payload = {
        page: page,
        params: {
          no_of_rows: 10,
        },
      };
      if (!_.isEmpty(searchPayload.value))
        payload["params"] = {
          ...(payload.params && { ...payload.params }),
          ...searchPayload.value,
        };
      root.$store.dispatch("ordersDineIn/getOrdersDineInList", payload);
    };
    const handlePageSearch = (filters) => {
      searchPayload.value = {
        ...(_.has(searchPayload.value, "sort") &&
          Object.keys(searchPayload.value.sort).map((key) => {
            const item = {};
            item[`sort_${key}`] = searchPayload.value.sort[key];
            return item;
          })),
        ...filters,
      };
      applySearchPayload();
    };
    const handlePagination = (page) => {
      applySearchPayload(page);
    };
    const handleTableSort = ({ sort }) => {
      Object.keys(sort).forEach(
        (key) => (searchPayload.value[`sort_${key}`] = sort[key])
      );
      applySearchPayload();
    };
    applySearchPayload();

    return {
      handlePageSearch,
      handlePagination,
      handleTableSort,
    };
  },
});
</script>
